<div class="flex-row column position-relative">
  <div class="bg-color-F3F6FB p-20">
    <div class="flex-row column full">
      <div class="flex-row full content-between align-center">
        <p class="text-dark fw-6 fs-20 mb-5 color-md-808699-imp fs-md-18 fw-md-8">Rebalancing Updates</p>
        <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="close()"
          aria-label="Close Rebalancing Dialog">
          <x-icon class="cursor-pointer" [width]="'20'"></x-icon>
        </button>
      </div>
      <span class="color-primary fs-md-14">Posted on {{subscriptionData.wealthcase.rebalancingDate | date:
        'mediumDate'}}</span>
      <span class="fs-12 fw-4 lh-16 text-dark mt-4">Please maintain sufficient balance in your Demat Account</span>
    </div>
    <div class="flex-row full flex-wrap-md row-gap-12 content-between pt-12 mt-12 border-top-2"
      style="border-color: #fff !important;" *ngIf="calculatedValue">
      <div class="flex-row column">
        <p class="fs-12 lh-16 fw-3 color-505563">Sell amount</p>
        <p class="fs-14 lh-22 fw-4 text-dark">{{calculatedValue?.sellAmount| number: '1.2-2'}}</p>
      </div>
      <div class="flex-row column">
        <p class="fs-12 lh-16 fw-3 color-505563">Buy amount</p>
        <p class="fs-14 lh-22 fw-4 text-dark">{{calculatedValue?.buyAmount| number: '1.2-2'}}</p>
      </div>
      <div class="flex-row column flex-row-md full-md content-between-md">
        <div class="flex-row align-center column-gap-4">
          <p class="fs-12 lh-16 fw-3 color-505563">Amount required in demat
          </p>
          <app-tooltip
            [content]="'<p>This is the amount you should have in your Demat/ Trading account to place a successful rebalancing order.Amt required in Demat = Buy Amt - 60% of Sell Amt</p>'"
            [position]="'left'">
            <img class="width-18-px cursor-pointer fs-12" src="assets/new-assets/icons/icon-info.svg" alt="Info">
          </app-tooltip>
        </div>
        <p class="fs-14 lh-22 fw-4 text-dark" *ngIf="calculatedValue?.requiredInDemat>0">
          {{calculatedValue?.requiredInDemat| number: '1.2-2'}}</p>
        <p class="fs-14 lh-22 fw-4 text-dark" *ngIf="calculatedValue?.requiredInDemat<=0">--</p>
      </div>
    </div>
  </div>
  <div class="flex-row column p-20 bg-secondary mt-20 mb-20" *ngIf="isNotInvested">
    <div class="flex-row align-center mb-15">
      <img class="mr-10" src="assets/new-assets/icons/icon-info-danger.svg" alt="Info important">
      <p class="fs-14 fw-8 text-danger">Important</p>
    </div>
    <p class="text-dark fs-14" style="line-height: 1.43;">We don’t have your investment details. Hence we can’t auto
      calculate changes. Please add your investment</p>
  </div>
  <span class="text-danger fs-13 mt-20 mb-5 text-center" *ngIf="data.marketEnded">Cannot place order outside market
    hours</span>
  <div class="flex-row column mt-20 mb-20" *ngIf="subscriptionData?.wealthcase?.rebalancingComments">
    <div class="flex-row align-center mb-10">
      <img src="assets/new-assets/icons/icon-whats-new.svg" alt="What's new">
      <p class="fw-5 ml-6 text-dark">What's New</p>
    </div>
    <p>{{subscriptionData?.wealthcase?.rebalancingComments}}</p>
  </div>
  <div class="flex-row align-center p-20">
    <img class="width-4 height-4" src="assets/new-assets/icons/icon-rebalance.svg" alt="Rebelance">
    <p class="fw-5 ml-6 text-dark">Rebalanced Portfolio</p>
  </div>
  <div class="flex-row column overflow-hidden overflow-y height-405-px pb-170 height-md-60-vh">
    <div class="flex-row column full pl-10 pr-10 pl-md-0 pr-md-0">
      <ng-container *ngIf="(rebalanceInstruments | categoryFilter:'rebalance').equity | stockBuySell:'BUY'">
        <div
          class="flex-row align-center content-between mt-10 mb-10 pt-5 pb-5 pl-30 pr-30 pl-md-20 pr-md-20 bg-color-F3F6FB">
          <p class="fs-14 fw-6 text-dark">EQUITY</p>
          <div class="color-01AE45 bg-color-CCEFDA fs-12 ptb-2 plr-10 fw-6 border-radius-4">BUY</div>
        </div>
        <ng-container *ngFor="let stocks of (rebalanceInstruments | categoryFilter:'rebalance').equity;let i= index">
          <ng-container *ngIf="stocks.activity === 'increase' || stocks.activity === 'new'">
            <div
              class="flex-row content-between align-start border-bottom-1 column p-15 p-md-20 color-primary row-gap-10"
              [ngClass]="{'border-bottom-none': i+1 === (rebalanceInstruments | categoryFilter:'rebalance').equity.length}">
              <div class="flex-row content-between text-dark fs-16 fs-md-14 fw-6 full">
                {{stocks.tradingSymbol}}
                <span class="text-primary fw-4">{{stocks?.activity | rebalanceActivity}}</span>
              </div>
              <div class="flex-row content-between full fs-14 fs-md-12">
                <span>CMP {{stocks.currentPrice}}</span>
              </div>
              <div class="flex-row full content-between mt-15 mt-md-10">
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Existing Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.existingQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Suggested Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.newQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Difference
                  <span
                    class="flex-row align-center content-between height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16 border-color-4334ec"
                    *ngIf="subscriptionData.wealthcase.type !='aum'">
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD" [disabled]="stocks.quantity == 0"
                      aria-label="Decrease Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'decrease')">-</button>
                    <span class="height-12-px">{{stocks?.quantity}}</span>
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Increase Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'increase')">+</button>
                  </span>
                  <span class="flex-row height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16"
                    *ngIf="subscriptionData.wealthcase.type =='aum'">
                    <span>{{stocks?.quantity}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(rebalanceInstruments | categoryFilter:'rebalance').etf | stockBuySell:'BUY'">
        <div
          class="flex-row align-center content-between mt-10 mb-10 pt-5 pb-5 pl-30 pr-30 pl-md-20 pr-md-20 bg-color-F3F6FB">
          <p class="fs-14 fw-6 text-dark">ETF</p>
          <div class="color-01AE45 bg-color-CCEFDA fs-12 ptb-2 plr-10 fw-6 border-radius-4">BUY</div>
        </div>
        <ng-container *ngFor="let stocks of (rebalanceInstruments | categoryFilter:'rebalance').etf;let i= index">
          <ng-container *ngIf="stocks.activity === 'increase' || stocks.activity === 'new'">
            <div
              class="flex-row content-between border-bottom-1 align-start column p-15 p-md-20 color-primary row-gap-10"
              [ngClass]="{'border-bottom-none': i+1 === (rebalanceInstruments | categoryFilter:'rebalance').etf.length}">
              <div class="flex-row content-between text-dark fs-16 fs-md-14 fw-6 full">
                {{stocks.tradingSymbol}}
                <span class="text-primary fw-4">{{stocks?.activity | rebalanceActivity}}</span>
              </div>
              <div class="flex-row content-between full fs-14 fs-md-12">
                <span>CMP {{stocks.currentPrice}}</span>
              </div>
              <div class="flex-row full content-between mt-15 mt-md-10">
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Existing Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.existingQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Suggested Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.newQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Difference
                  <span
                    class="flex-row align-center content-between height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16 border-color-4334ec"
                    *ngIf="subscriptionData.wealthcase.type !='aum'">
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD" [disabled]="stocks.quantity == 0"
                      aria-label="Decrease Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'decrease')">-</button>
                    <span class="height-12-px">{{stocks?.quantity}}</span>
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Increase Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'increase')">+</button>
                  </span>
                  <span class="flex-row height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16"
                    *ngIf="subscriptionData.wealthcase.type =='aum'">
                    <span>{{stocks?.quantity}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(rebalanceInstruments | categoryFilter:'rebalance').gold | stockBuySell:'BUY'">
        <div
          class="flex-row align-center content-between mt-10 mb-10 pt-5 pb-5 pl-30 pr-30 pl-md-20 pr-md-20 bg-color-F3F6FB">
          <p class="fs-14 fw-6 text-dark">GOLD</p>
          <div class="color-01AE45 bg-color-CCEFDA fs-12 ptb-2 plr-10 fw-6 border-radius-4">BUY</div>
        </div>
        <ng-container *ngFor="let stocks of (rebalanceInstruments | categoryFilter:'rebalance').gold;let i= index">
          <ng-container *ngIf="stocks.activity === 'increase' || stocks.activity === 'new'">
            <div
              class="flex-row content-between border-bottom-1 align-start column p-15 p-md-20 color-primary row-gap-10"
              [ngClass]="{'border-bottom-none': i+1 === (rebalanceInstruments | categoryFilter:'rebalance').gold.length}">
              <div class="flex-row content-between text-dark fs-16 fs-md-14 fw-6 full">
                {{stocks.tradingSymbol}}
                <span class="text-primary fw-4">{{stocks?.activity | rebalanceActivity}}</span>
              </div>
              <div class="flex-row content-between full fs-14 fs-md-12">
                <span>CMP {{stocks.currentPrice}}</span>
              </div>
              <div class="flex-row full content-between mt-15 mt-md-10">
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Existing Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.existingQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Suggested Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.newQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Difference
                  <span
                    class="flex-row align-center content-between height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16 border-color-4334ec"
                    *ngIf="subscriptionData.wealthcase.type !='aum'">
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD" [disabled]="stocks.quantity == 0"
                      aria-label="Decrease Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'decrease')">-</button>
                    <span class="height-12-px">{{stocks?.quantity}}</span>
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Increase Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'increase')">+</button>
                  </span>
                  <span class="flex-row height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16"
                    *ngIf="subscriptionData.wealthcase.type =='aum'">
                    <span>{{stocks?.quantity}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(rebalanceInstruments | categoryFilter:'rebalance').mutualFund | stockBuySell:'BUY'">
        <div
          class="flex-row align-center content-between mt-10 mb-10 pt-5 pb-5 pl-30 pr-30 pl-md-20 pr-md-20 bg-color-F3F6FB">
          <p class="flex-2">MUTUAL FUNDS</p>
          <div class="color-01AE45 bg-color-CCEFDA fs-12 ptb-2 plr-10 fw-6 border-radius-4">BUY</div>
        </div>
        <ng-container
          *ngFor="let stocks of (rebalanceInstruments | categoryFilter:'rebalance').mutualFund;let i= index">
          <ng-container *ngIf="stocks.activity === 'increase' || stocks.activity === 'new'">
            <div
              class="flex-row content-between border-bottom-1 align-start column p-15 p-md-20 color-primary row-gap-10"
              [ngClass]="{'border-bottom-none': i+1 === (rebalanceInstruments | categoryFilter:'rebalance').mutualFund.length}">
              <div class="flex-row content-between text-dark fs-16 fs-md-14 fw-6 full">
                <span class="max-width-28">{{stocks.name}}</span>
                <span class="text-primary fw-4">{{stocks?.activity | rebalanceActivity}}</span>
              </div>
              <div class="flex-row content-between full fs-14 fs-md-12">
                <span>Nav {{stocks?.currentPrice | number: '1.2-2'}}</span>
                <span
                  [class]="stocks.activity === 'decrease' || stocks.activity === 'exit'?'text-danger':'text-success'">{{stocks.activity
                  === 'decrease' || stocks.activity === 'exit'? 'SELL': 'BUY'}}</span>
              </div>
              <div class="flex-row full content-between mt-15 mt-md-10">
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Existing Amt.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.existingInvestment
                    | number: '1.2-2'}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Suggested Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.newInvestMent
                    | number: '1.2-2'}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-14 row-gap-6">
                  Difference
                  <span
                    class="flex-row align-center content-between height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16 border-color-4334ec"
                    *ngIf="subscriptionData.wealthcase.type !='aum'">
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Decrease Stock Quantity by 1" [disabled]="stocks.investment == 0"
                      (click)="decreaseIncreaseQty(stocks,'decrease')">-</button>
                    <span class="height-12-px">{{stocks?.investment | number: '1.2-2'}}</span>
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Increase Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'increase')">+</button>
                  </span>
                  <span class="flex-row height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16"
                    *ngIf="subscriptionData.wealthcase.type =='aum'">
                    <span>{{stocks?.investment | number: '1.2-2'}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(rebalanceInstruments | categoryFilter:'rebalance').equity | stockBuySell:'SELL'">
        <div
          class="flex-row align-center content-between mt-10 mb-10 pt-5 pb-5 pl-30 pr-30 pl-md-20 pr-md-20 bg-color-F3F6FB">
          <p class="fs-14 fw-6 text-dark">EQUITY</p>
          <div class="color-E51919 bg-color-FAD1D1 fs-12 ptb-2 plr-10 fw-6 border-radius-4">SELL</div>
        </div>
        <ng-container *ngFor="let stocks of (rebalanceInstruments | categoryFilter:'rebalance').equity;let i= index">
          <ng-container *ngIf="stocks.activity === 'decrease' || stocks.activity === 'exit'">
            <div
              class="flex-row content-between align-start border-bottom-1 column p-15 p-md-20 color-primary row-gap-10"
              [ngClass]="{'border-bottom-none': i+1 === (rebalanceInstruments | categoryFilter:'rebalance').equity.length}">
              <div class="flex-row content-between text-dark fs-16 fs-md-14 fw-6 full">
                {{stocks.tradingSymbol}}
                <span class="text-primary fw-4">{{stocks?.activity | rebalanceActivity}}</span>
              </div>
              <div class="flex-row content-between full fs-14 fs-md-12">
                <span>CMP {{stocks.currentPrice}}</span>
              </div>
              <div class="flex-row full content-between mt-15 mt-md-10">
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Existing Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.existingQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Suggested Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.newQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Difference
                  <span
                    class="flex-row align-center content-between height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16 border-color-4334ec"
                    *ngIf="subscriptionData.wealthcase.type !='aum'">
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD" [disabled]="stocks.quantity == 0"
                      aria-label="Decrease Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'decrease')">-</button>
                    <span class="height-12-px">{{stocks?.quantity}}</span>
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Increase Stock Quantity by 1" (click)="decreaseIncreaseQty(stocks,'increase')"
                      [disabled]="stocks.quantity == stocks?.existingQuantity">+</button>
                  </span>
                  <span class="flex-row height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16"
                    *ngIf="subscriptionData.wealthcase.type =='aum'">
                    <span>{{stocks?.quantity}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(rebalanceInstruments | categoryFilter:'rebalance').etf | stockBuySell:'SELL'">
        <div
          class="flex-row align-center content-between mt-10 mb-10 pt-5 pb-5 pl-30 pr-30 pl-md-20 pr-md-20 bg-color-F3F6FB">
          <p class="fs-14 fw-6 text-dark">ETF</p>
          <div class="color-E51919 bg-color-FAD1D1 fs-12 ptb-2 plr-10 fw-6 border-radius-4">SELL</div>
        </div>
        <ng-container *ngFor="let stocks of (rebalanceInstruments | categoryFilter:'rebalance').etf;let i= index">
          <ng-container *ngIf="stocks.activity === 'decrease' || stocks.activity === 'exit'">
            <div
              class="flex-row content-between border-bottom-1 align-start column p-15 p-md-20 color-primary row-gap-10"
              [ngClass]="{'border-bottom-none': i+1 === (rebalanceInstruments | categoryFilter:'rebalance').etf.length}">
              <div class="flex-row content-between text-dark fs-16 fs-md-14 fw-6 full">
                {{stocks.tradingSymbol}}
                <span class="text-primary fw-4">{{stocks?.activity | rebalanceActivity}}</span>
              </div>
              <div class="flex-row content-between full fs-14 fs-md-12">
                <span>CMP {{stocks.currentPrice}}</span>
              </div>
              <div class="flex-row full content-between mt-15 mt-md-10">
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Existing Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.existingQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Suggested Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.newQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Difference
                  <span
                    class="flex-row align-center content-between height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16 border-color-4334ec"
                    *ngIf="subscriptionData.wealthcase.type !='aum'">
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD" [disabled]="stocks.quantity == 0"
                      aria-label="Decrease Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'decrease')">-</button>
                    <span class="height-12-px">{{stocks?.quantity}}</span>
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Increase Stock Quantity by 1" (click)="decreaseIncreaseQty(stocks,'increase')"
                      [disabled]="stocks.quantity == stocks?.existingQuantity">+</button>
                  </span>
                  <span class="flex-row height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16"
                    *ngIf="subscriptionData.wealthcase.type =='aum'">
                    <span>{{stocks?.quantity}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(rebalanceInstruments | categoryFilter:'rebalance').gold | stockBuySell:'SELL'">
        <div
          class="flex-row align-center content-between mt-10 mb-10 pt-5 pb-5 pl-30 pr-30 pl-md-20 pr-md-20 bg-color-F3F6FB">
          <p class="fs-14 fw-6 text-dark">GOLD</p>
          <div class="color-E51919 bg-color-FAD1D1 fs-12 ptb-2 plr-10 fw-6 border-radius-4">SELL</div>
        </div>
        <ng-container *ngFor="let stocks of (rebalanceInstruments | categoryFilter:'rebalance').gold;let i= index">
          <ng-container *ngIf="stocks.activity === 'decrease' || stocks.activity === 'exit'">
            <div
              class="flex-row content-between border-bottom-1 align-start column p-15 p-md-20 color-primary row-gap-10"
              [ngClass]="{'border-bottom-none': i+1 === (rebalanceInstruments | categoryFilter:'rebalance').gold.length}">
              <div class="flex-row content-between text-dark fs-16 fs-md-14 fw-6 full">
                {{stocks.tradingSymbol}}
                <span class="text-primary fw-4">{{stocks?.activity | rebalanceActivity}}</span>
              </div>
              <div class="flex-row content-between full fs-14 fs-md-12">
                <span>CMP {{stocks.currentPrice}}</span>
              </div>
              <div class="flex-row full content-between mt-15 mt-md-10">
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Existing Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.existingQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Suggested Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.newQuantity}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Difference
                  <span
                    class="flex-row align-center content-between height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16 border-color-4334ec"
                    *ngIf="subscriptionData.wealthcase.type !='aum'">
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD" [disabled]="stocks.quantity == 0"
                      aria-label="Decrease Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'decrease')">-</button>
                    <span class="height-12-px">{{stocks?.quantity}}</span>
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Increase Stock Quantity by 1" (click)="decreaseIncreaseQty(stocks,'increase')"
                      [disabled]="stocks.quantity == stocks?.existingQuantity">+</button>
                  </span>
                  <span class="flex-row height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16"
                    *ngIf="subscriptionData.wealthcase.type =='aum'">
                    <span>{{stocks?.quantity}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="(rebalanceInstruments | categoryFilter:'rebalance').mutualFund | stockBuySell:'SELL'">
        <div
          class="flex-row align-center content-between mt-10 mb-10 pt-5 pb-5 pl-30 pr-30 pl-md-20 pr-md-20 bg-color-F3F6FB">
          <p class="flex-2">MUTUAL FUNDS</p>
          <div class="color-E51919 bg-color-FAD1D1 fs-12 ptb-2 plr-10 fw-6 border-radius-4">SELL</div>
        </div>
        <ng-container
          *ngFor="let stocks of (rebalanceInstruments | categoryFilter:'rebalance').mutualFund;let i= index">
          <ng-container *ngIf="stocks.activity === 'decrease' || stocks.activity === 'exit'">
            <div
              class="flex-row content-between border-bottom-1 align-start column p-15 p-md-20 color-primary row-gap-10"
              [ngClass]="{'border-bottom-none': i+1 === (rebalanceInstruments | categoryFilter:'rebalance').mutualFund.length}">
              <div class="flex-row content-between text-dark fs-16 fs-md-14 fw-6 full">
                <span class="max-width-28">{{stocks.name}}</span>
                <span class="text-primary fw-4">{{stocks?.activity | rebalanceActivity}}</span>
              </div>
              <div class="flex-row content-between full fs-14 fs-md-12">
                <span>Nav {{stocks?.currentPrice | number: '1.2-2'}}</span>
                <span
                  [class]="stocks.activity === 'decrease' || stocks.activity === 'exit'?'text-danger':'text-success'">{{stocks.activity
                  === 'decrease' || stocks.activity === 'exit'? 'SELL': 'BUY'}}</span>
              </div>
              <div class="flex-row full content-between mt-15 mt-md-10">
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Existing Amt.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.existingInvestment
                    | number: '1.2-2'}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-9 row-gap-6">
                  Suggested Qty.
                  <span
                    class="flex-row align-center bg-color-FBFDFD border-radius-4 text-left p-10 fs-md-14 fw-6 fs-16 height-5 height-md-4">{{stocks?.newInvestMent
                    | number: '1.2-2'}}</span>
                </div>
                <div class="flex-row column fs-md-12 fs-14 width-12 width-md-14 row-gap-6">
                  Difference
                  <span
                    class="flex-row align-center content-between height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16 border-color-4334ec"
                    *ngIf="subscriptionData.wealthcase.type !='aum'">
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Decrease Stock Quantity by 1" [disabled]="stocks.investment == 0"
                      (click)="decreaseIncreaseQty(stocks,'decrease')">-</button>
                    <span class="height-12-px">{{stocks?.investment | number: '1.2-2'}}</span>
                    <button type="button" class="text-blue fw-8 fs-20 bg-color-FBFDFD"
                      aria-label="Increase Stock Quantity by 1"
                      (click)="decreaseIncreaseQty(stocks,'increase')">+</button>
                  </span>
                  <span class="flex-row height-5 height-md-4 bg-color-FBFDFD border-radius-4 p-10 fs-md-14 fw-6 fs-16"
                    *ngIf="subscriptionData.wealthcase.type =='aum'">
                    <span>{{stocks?.investment | number: '1.2-2'}}</span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div class="flex-row full bg-white p-20 border-top-1 position-absolute column-md row-gap-md-20" style="bottom:0;">
    <ng-container *ngIf="!isNotInvested">
      <button type="button" class="btn btn-primary full-md mr-20 mr-md-0" debounceClick (debounceclicked)="rebalance()"
        [disabled]="data.marketEnded">Rebalance</button>
      <button type="button" class="btn btn-outline width-100-pr border-none-md" (click)="close('external')">I've done
        rebalancing outside</button>
    </ng-container>
    <ng-container *ngIf="isNotInvested">
      <button type="button" class="btn btn-primary mr-20 full-md" (click)="close('external')">Add Investments</button>
    </ng-container>
  </div>
</div>